/**
 * Contract for global chrome that sits above the app and pushes fixed/sticky app surfaces down.
 *
 * Today the only publisher is the sales demo's PersonaBar (see components/demo/PersonaBar.tsx),
 * but nothing here says so — the name is deliberately generic so any future global bar (a
 * maintenance banner, an impersonation strip) can adopt the same contract. Consumers (sidebars,
 * app bars) read this file, not the demo layer, and so stay unaware that the demo is what happens
 * to be publishing it today.
 *
 * When nothing publishes the property, `APP_CHROME_OFFSET` resolves to `0px` — exactly the
 * pre-existing, non-demo layout.
 */
export const APP_CHROME_OFFSET_VAR = '--app-chrome-offset';

/** `var()` expression fixed/sticky surfaces use for `top` (and, for full-height panels, to
 * subtract from `height`). */
export const APP_CHROME_OFFSET = `var(${APP_CHROME_OFFSET_VAR}, 0px)`;
